import { DateTime } from 'luxon';

import { setLongTermContractAttributes } from '@pharmaplan/common';

import { useCallback } from 'react';
import { toJSDate } from '../../components/Dashboard/MainCalendar/helpers';
import { getDayMonthDateYear } from '../../components/Reports/helpers';
import { toStandardFormat } from '../../helpers/Functions';
import { useAppDispatch } from '../useAppDispatch';
import strings from '../../localization';

import useGenerateContractRange from './useGenerateContractRange';

const useUpdateContract = () => {
  const dispatch = useAppDispatch();
  const { getInitialShiftAttributes } = useGenerateContractRange();

  const formatDisplayDate = useCallback((contractStart?: string, contractEnd?: string) => {
    if (contractStart && contractEnd) {
      const start = DateTime.fromISO(contractStart, { setZone: true });
      const end = DateTime.fromISO(contractEnd, { setZone: true });

      const dateString = `${getDayMonthDateYear(toStandardFormat(start))} ${strings.to
      } ${getDayMonthDateYear(toStandardFormat(end))}`;
      return dateString;
    }

    return '';
  }, []);

  const setAttributes = (contractStart?: string, contractEnd?: string) => {
    if (contractStart && contractEnd) {
      const start = DateTime.fromISO(contractStart, { setZone: true });
      const end = DateTime.fromISO(contractEnd, { setZone: true });
      const sTime = toJSDate(contractStart);
      const eTime = toJSDate(contractEnd);

      dispatch(setLongTermContractAttributes({
        defaultStartTime: sTime,
        defaultEndTime: eTime,
        startDate: start,
        endDate: end,
        shiftContractAttributes: getInitialShiftAttributes({
          endDate: end,
          startDate: start,
          endTime: eTime,
          startTime: sTime,
          isUpdate: true,
        }),
      }));
    }
  };

  return { setAttributes, formatDisplayDate };
};

export default useUpdateContract;
